import { matchPath } from 'react-router-dom';
import { ROUTE_TITLES } from '@/lib/route-titles';

/** Returned for a pathname no route pattern matches. Should be unreachable: `ROUTE_TITLES` ends in `*`. */
export const UNMATCHED_ROUTE_PATTERN = 'unmatched';

/**
 * KB-4771 — the route pattern a pathname renders (`/organizations/abc123/edit`
 * → `/organizations/:id/edit`), so a page view carries no document id.
 *
 * Reuses `ROUTE_TITLES` and the same first-match walk as `getTitleForPath`, so
 * the title and the pattern of a page view can never describe different routes.
 */
export function getRoutePatternForPath(pathname: string): string {
  for (const entry of ROUTE_TITLES) {
    if (matchPath({ path: entry.path, end: true }, pathname)) {
      return entry.path;
    }
  }
  return UNMATCHED_ROUTE_PATTERN;
}
